import { render, staticRenderFns } from "./CategoryImageCarousel.vue?vue&type=template&id=46203a72"
import script from "./CategoryImageCarousel.vue?vue&type=script&lang=js"
export * from "./CategoryImageCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports